// extracted by mini-css-extract-plugin
export default {"table":"blockedProfileTypes_table__BPyCw"};